import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { WrapperField } from '../../../../../components/InputField/WrapperField';
import { DialogContext } from '../../../../../store/context/DialogContext';
import { useTranslation } from '../../../../../store/context/TranslationContext';
import ButtonGroupNew from '../../BusinessLiteForms/components/ButtonGroupNew';
import { InputLabel } from '../../components/IndividualLite/UserDetailsForm';
import { getNextStep, getVisibleWizardFieldOrder, WIZARD_NUM } from '../helper';
import { FORM_TYPE } from '../../IPlushelper';

const SelfDeclaration = ({
    asLabel,
    hideButtons,
    data,
    handleUpdate,
    hasError,
    setHasError,
    loading,
    cyclosFields,
    errors,
    setErrors,
    iPlusFields,
    wizard,
    isForEDD,
    handleChange,
    handlePrev,
    applicationForm,
    setData,
    editMode
}) => {
    const { showError } = useContext(DialogContext);
    const { t } = useTranslation();

    const checkNext = () => {
        const visibleFieldOrder = getVisibleWizardFieldOrder({
            fields: iPlusFields,
            wizard,
            data,
        });

        for (const fieldPath of visibleFieldOrder) {
            const fieldError = _.get(errors, fieldPath);
            if (fieldError) {
                setHasError(true);
                if (fieldError) {
                    showError(fieldError);
                    return false;
                }
            }
        }

        setErrors({});
        return true;
    };


    const handleSubmit = async () => {
        const isFormFieldValid = checkNext();
        if (isFormFieldValid) {
            setHasError(false);
            if (applicationForm?.formType === FORM_TYPE.BusinessPlus) {
                return handleUpdate({
                    isLastStep: true,
                    isfetchDetail: true
                });
            } else {
                return handleUpdate({
                    nextStep: getNextStep(wizard, applicationForm, data, editMode)
                });
            }
        }
    };

    const handleUpdateFormData = (updatedData) => {
        handleChange(updatedData);
    };

    const handleErrors = (field, errorMsg) => {
        setErrors((prevErrors) => {
            const updatedErrors = _.cloneDeep(prevErrors);
            updatedErrors[field] = errorMsg;
            return updatedErrors;
        });
    };

    return (
        <div className="row">
            <div className="col-12">
                <h2 style={{ fontWeight: 'bolder' }} className='pt-3 mb-4'>Self Declaration</h2>

                <div className='d-flex row justify-content-start mb-4'>
                    <div className='flex-1'>
                        <WrapperField
                            disabled={asLabel}
                            jsonField={cyclosFields["acceptDelarationAggrement"]}
                            dataObj={data}
                            onChange={handleUpdateFormData}
                            showError={hasError}
                            onError={(errorMsg) => handleErrors('acceptDelarationAggrement', errorMsg)}
                            isForEDD={isForEDD}
                        />

                    </div>

                    <InputLabel label="Signature of Applicant" required />

                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["signature"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('signature', errorMsg)}
                        isForEDD={isForEDD}
                    />


                    <InputLabel required label={"Name of Applicant"} labelStyle={{ fontSize: 15 }} />
                    <div className='row'>
                        <div className='col-sm-4'>
                            <WrapperField
                                disabled={asLabel}
                                jsonField={cyclosFields["signerFirstName"]}
                                dataObj={data}
                                onChange={handleUpdateFormData}
                                showError={hasError}
                                onError={(errorMsg) => handleErrors('signerFirstName', errorMsg)}
                                isForEDD={isForEDD}
                            />
                        </div>
                        <div className='col-sm-4'>
                            <WrapperField
                                disabled={asLabel}
                                jsonField={cyclosFields["signerMiddleName"]}
                                dataObj={data}
                                onChange={handleUpdateFormData}
                                showError={hasError}
                                onError={(errorMsg) => handleErrors('signerMiddleName', errorMsg)}
                                isForEDD={isForEDD}
                            />
                        </div>
                        <div className='col-sm-4'>
                            <WrapperField
                                disabled={asLabel}
                                jsonField={cyclosFields["signerLastName"]}
                                dataObj={data}
                                onChange={handleUpdateFormData}
                                showError={hasError}
                                onError={(errorMsg) => handleErrors('signerLastName', errorMsg)}
                                isForEDD={isForEDD}
                            />
                        </div>

                    </div>
                </div>

                <div className='mt-4'>
                    <ButtonGroupNew
                        onNextClick={handleSubmit}
                        onBackClick={() => { handlePrev() }}
                        step={WIZARD_NUM.SelfDeclaration}
                        showPageNum={false}
                        pageNum={WIZARD_NUM.SelfDeclaration}
                        hideSubmitButton={hideButtons}
                        asLabel={false}
                        nextText={applicationForm?.formType == FORM_TYPE.BusinessPlus ? t("Submit") : t("Next")}
                        loading={loading}
                    />
                </div>
            </div>
        </div>
    );
};

export default observer(SelfDeclaration);
